/*
 * @Author: cmchiu
 * @Date: 2022-03-31 10:16:57
 * @LastEditTime: 2023-06-02 14:55:02
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \campus2022\campus2022-ClientApp\src\settings.js
 *
 */
const campusBaseURL = process.env.VUE_APP_CampusURL //|| '//campus.sce.pccu.edu.tw/'
const icanBaseURL = process.env.VUE_APP_iCanURL //|| '//ican.sce.pccu.edu.tw/'

module.exports = {
    title: '虛擬校園 | 學士班 碩士班 | 中國文化大學推廣教育部',

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: false,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    sidebarLogo: true,

    url: {
        /* Layout - header */
        exam: '//exam.sce.pccu.edu.tw/', //考生
        alumni: `${campusBaseURL}alumni/`, //校友
        newstud: '//edurp.sce.pccu.edu.tw/webRegister/Login.aspx', //新生
        college: `${campusBaseURL}academic/college`, //進修學制
        manage: `${campusBaseURL}manage/manage`, //行政單位
        source: `${campusBaseURL}source/source`, //學習資源
        award: `${campusBaseURL}award/award`, //獎助學金
        schedule: `${campusBaseURL}calendar/schedule`, //行事曆
        downloadcalendar: `${campusBaseURL}calendar/postnews?QueryBoardId=B20050907000027&blockid=1000310006000005`, //學年期行事曆
        faq: `${icanBaseURL}ican5/faq/faq.aspx?title=FAQ&txtTocNo=105620`, //常見問題
        forgotpw: `//ican.sce.pccu.edu.tw/member/forgetpassword.aspx`, //忘記密碼
        ican: `${icanBaseURL}login.aspx?mid=1`, //iCAN學習
        portfolio: `${icanBaseURL}login.aspx?mid=72`, //學習歷程
        academic: `${icanBaseURL}login.aspx?mid=2`, //教務服務
        service: `${icanBaseURL}login.aspx?mid=4`, //個人服務
        message: `${icanBaseURL}ican5/Message/Message.aspx`, //留言
        learningmap: '//edurp.sce.pccu.edu.tw/CLM/', //學習地圖
        /* Home */
        ipr: '//ipr.pccu.edu.tw/', //智慧財產權
        geec: '//geec.pccu.edu.tw/', //性別平等教育委員會
        house: '//house.nfu.edu.tw/pccu', //校外賃居網
        nosmoking: '//www.sce.pccu.edu.tw/event/2012/20121026079/', //無菸校園
        bullying: '//anti-bully.pccu.edu.tw/index.php', //防制校園霸凌
        /* Footer */
        suggestion: `${icanBaseURL}suggestion/campus.aspx`, //意見信箱
        traffic: `${campusBaseURL}board/postnews?QueryBoardId=B20110812000001&blockid=1000310006000048`, //交通資訊
    },
}
